export default "__VITE_ASSET__DqaaYf57__"